/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DoctorSpeciality } from '../models/DoctorSpeciality';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TardocDoctorSpecialitiesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieve the list of TARDOC doctor specialities from Azure Search.
     *
     * Returns a list of unique medical specialities extracted from the TARDOC
     * billing codes index. The results are cached for performance.
     * @returns DoctorSpeciality
     * @throws ApiError
     */
    public tardocDoctorSpecialityList(): CancelablePromise<Array<DoctorSpeciality>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/tardoc-doctor-specialities/',
        });
    }
}
